import React from "react";
import { Animate } from "react-move";

import { easeBounceOut } from "@/utils/animation";
import base64 from "@/utils/base64";

import { Point } from "../MeterConstants";

export type MeterVoteHandleProps = {
  icons: IIcons;
  voteUserIconHandle?: Point;
  dropVoteUserIconHandle: boolean;
};

export default class MeterUserIconHandle extends React.Component<
  MeterVoteHandleProps,
  {}
> {
  public render(): JSX.Element {
    const { icons, voteUserIconHandle, dropVoteUserIconHandle } = this.props;

    return (
      <g>
        {voteUserIconHandle && (
          <Animate
            start={{
              y: voteUserIconHandle.y,
            }}
            update={
              dropVoteUserIconHandle
                ? {
                    y: [voteUserIconHandle.y],
                    timing: {
                      duration: 1,
                    },
                  }
                : {
                    y: [voteUserIconHandle.y],
                    timing: {
                      duration: 700,
                      ease: easeBounceOut,
                    },
                  }
            }
          >
            {(animation: { y: number }) => (
              <g
                transform={`translate(${voteUserIconHandle.x}, ${
                  dropVoteUserIconHandle ? voteUserIconHandle.y : animation.y
                })`}
              >
                <image
                  xlinkHref={
                    "data:image/svg+xml;base64," + base64.encode(icons.Picker)
                  }
                  x={-(64 / 2)}
                  y={-(64 / 2)}
                  width={64}
                  height={64}
                  onDragStart={(e: React.MouseEvent) => e.preventDefault()}
                />
              </g>
            )}
          </Animate>
        )}
      </g>
    );
  }
}
